import axios from 'axios';

export type GlobalSettings = {
    softwareVersion: string;
    customerVersion: '' | 'ronik' | 'zxy';
    applicationTitle: string;
    useSso: boolean;
    forceSso: boolean;
    isInMaintenance: boolean;
    tenant: { name: string };
    sendBugReportLink: string;
    sendSupportRequestLink: string;
};

export function isAdministratorPortal(globalSettings: GlobalSettings) {
    return globalSettings.tenant.name === 'admin';
}

export async function fetchGlobalSettings() {
    const response = await axios<GlobalSettings>('/api/env');
    return response.data;
}
